import { render, staticRenderFns } from "./Nps.vue?vue&type=template&id=6b031a7c&scoped=true"
import script from "./Nps.vue?vue&type=script&lang=js"
export * from "./Nps.vue?vue&type=script&lang=js"
import style0 from "./Nps.scss?vue&type=style&index=0&id=6b031a7c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b031a7c",
  null
  
)

export default component.exports